var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 82,
    viewBox: "0 0 88 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11338_143774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3369 47.6877H31.0794C30.3402 47.6877 29.7378 47.0786 29.7378 46.331V29.1094C29.7378 28.3618 30.3402 27.7527 31.0794 27.7527H37.7054L38.5542 25.4823C38.7458 24.9563 39.2387 24.624 39.7863 24.624H48.5753C49.1229 24.624 49.6157 24.9563 49.8074 25.4823L50.6562 27.7527H57.2821C58.0214 27.7527 58.6237 28.3618 58.6237 29.1094V46.331C58.6785 47.0786 58.0761 47.6877 57.3369 47.6877ZM32.421 45.002H56.0226V30.4661H49.78C49.2324 30.4661 48.7395 30.1338 48.5479 29.6078L47.6991 27.3374H40.7446L39.8958 29.6078C39.7041 30.1338 39.2113 30.4661 38.6637 30.4661H32.421V45.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2217 43.4786C40.7445 43.4786 37.9243 40.5991 37.9243 37.0551C37.9243 33.5388 40.7445 30.687 44.2217 30.687C47.699 30.687 50.5191 33.5388 50.5191 37.0551C50.4918 40.5991 47.6716 43.4786 44.2217 43.4786ZM44.2217 33.4004C42.223 33.4004 40.6076 35.0339 40.6076 37.0551C40.6076 39.104 42.223 40.7929 44.2217 40.7929C46.2205 40.7929 47.8359 39.1317 47.8359 37.0551C47.8359 35.0616 46.2205 33.4004 44.2217 33.4004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11338_143774",
    x: -2.02815,
    y: -0.999862,
    width: 92.2546,
    height: 83.8678,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.79245
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.3774
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11338_143774"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11338_143774",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera1);
export default __webpack_public_path__ + "static/media/camera1.f3dda40a0422e578c6607732c875eacf.svg";
export { ForwardRef as ReactComponent };